import optc from '../optc.json';

export function resolveSelectedAgency(userAgencyResponse) {
  const list = Array.isArray(userAgencyResponse)
    ? userAgencyResponse.filter(Boolean)
    : (userAgencyResponse && userAgencyResponse !== 'admin' ? [userAgencyResponse] : []);

  const stored = typeof sessionStorage !== 'undefined'
    ? sessionStorage.getItem('selectedAgency')
    : null;

  if (stored && (list.length === 0 || list.includes(stored))) {
    return stored;
  }

  return list[0] || stored || '';
}

export function groupAgenciesByNom(agencies) {
  const byNom = [];
  const indexByNom = new Map();

  (agencies || []).forEach((agency) => {
    if (!agency || !agency.operateur) {
      return;
    }
    const nom = agency.nom || agency.operateur;
    if (!indexByNom.has(nom)) {
      indexByNom.set(nom, byNom.length);
      byNom.push({ nom, members: [] });
    }
    byNom[indexByNom.get(nom)].members.push(agency);
  });

  return byNom.map((group) => {
    if (group.members.length === 1) {
      return { type: 'agency', agency: group.members[0] };
    }
    return {
      type: 'group',
      nom: group.nom,
      country: group.members[0].country || '',
      region: group.members[0].region || '',
      color: group.members[0].color || '#4d0077',
      members: group.members
    };
  });
}

export function agencyDisplayName(agencyId) {
  if (!agencyId) {
    return '';
  }

  const match = optc.optc.find((entry) => entry.operateur === agencyId);
  if (!match) {
    return agencyId;
  }

  const hasMultipleOperators = optc.optc.filter((entry) => entry.nom === match.nom).length > 1;
  if (hasMultipleOperators && match.operateur && match.operateur !== match.nom) {
    return `${match.nom} · ${match.operateur}`;
  }

  return match.nom;
}
